import { Grid } from "@mui/material";
import React from "react";
import { useAuth } from "../../../../hooks";
import { toTitleCase } from "../../../../utils/stringUtils";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import QTAreasField from "../../../OrganizationQuickTales/components/QTDetailsDataFieldsSection/QTAreasField";

const DetailsPageTopCardSection = ({
  quicktaleDetails,
  setQuicktaleDetails,
  editEnabled,
}) => {
  const { currentUser } = useAuth();
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*Description section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Admin Note"}
          value={quicktaleDetails?.adminNote}
          disabled={true}
          multiline={true}
          rows={5}
          editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              adminNote: e.target.value,
            })
          }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*qt Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"QT Org Status"}
          value={toTitleCase(quicktaleDetails?.approvalStatus?.status)}
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["Approved", "Pending", "Denied", "Removed"]}
          onChange={(e) => {
            let temp = {
              status: e.target.value.toLowerCase(),
              updatedAt: new Date(),
              updatedBy: currentUser?.userName,
            };
            setQuicktaleDetails({
              ...quicktaleDetails,
              approvalStatus: temp,
            });
          }}
        />
        {/*Areas section — matches the regular QuickTale Detail page */}
        <QTAreasField
          areasMode={"orgMulti"}
          quicktaleDetails={quicktaleDetails}
          setQuicktaleDetails={setQuicktaleDetails}
          editEnabled={editEnabled}
        />
      </Grid>
    </Grid>
  );
};

export default DetailsPageTopCardSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
};
